import { FirefoxButton } from './containers/FirefoxButton'

export { FirefoxButton }



// WEBPACK FOOTER //
// ./client/Modules/AuthFirefox/index.js